import * as React from 'react';

const Mastercard = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <path
      d="M35.9619 8.3833C42.2034 8.3833 47.2637 13.3831 47.2637 19.5503C47.2635 25.7173 42.2033 30.7163 35.9619 30.7163C33.1635 30.7163 30.6046 29.7092 28.6309 28.0444C26.6572 29.7088 24.0989 30.7163 21.3008 30.7163C15.0596 30.7161 10.0002 25.7172 10 19.5503C10 13.3832 15.0595 8.3835 21.3008 8.3833C24.0986 8.3833 26.6573 9.39019 28.6309 11.0542C30.6045 9.38978 33.1638 8.38335 35.9619 8.3833Z"
      fill="#ED0006"
    />
    <path
      d="M35.9617 8.3833C42.2032 8.3833 47.2635 13.3831 47.2635 19.5503C47.2633 25.7173 42.203 30.7163 35.9617 30.7163C33.1638 30.7162 30.6052 29.7096 28.6316 28.0454C31.0604 25.9973 32.6022 22.9526 32.6023 19.5503C32.6023 16.1478 31.0606 13.1024 28.6316 11.0542C30.6052 9.39005 33.1639 8.3834 35.9617 8.3833Z"
      fill="#F9A000"
    />
    <path
      d="M28.6307 11.0538C31.0601 13.102 32.6024 16.1471 32.6024 19.5499C32.6024 22.9525 31.0598 25.9969 28.6307 28.045C26.2023 25.9969 24.661 22.952 24.661 19.5499C24.661 16.1476 26.202 13.102 28.6307 11.0538Z"
      fill="#FF5E00"
    />
  </svg>
);

export default Mastercard;
